import { ChatSocketService } from '@agent/agent-interface/contact-view/chat/services/chat-socket.service';
import { Component, Inject, Input, OnInit } from '@angular/core';

import { Formly, QUALIFICATION_FORMLY, QualificationService, UntilDestroy } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'chat-qualification',
  templateUrl: 'chat-qualification.component.html',
  styleUrls: ['./chat-qualification.component.scss'],
  providers: [
    {
      provide: QUALIFICATION_FORMLY,
      useClass: Formly,
    },
  ],
})
export class ChatQualificationComponent implements OnInit {
  @Input()
  responseId: string;

  constructor(private readonly chatSocketService: ChatSocketService, @Inject(QUALIFICATION_FORMLY) private readonly formly: Formly) {}

  ngOnInit(): void {
    this.formly.setId(QualificationService.toFormId(this.responseId));
    if (!this.responseId && !!this.chatSocketService.activeChat) {
      this.responseId = this.chatSocketService.activeChat.responseId;
    }
    if (!this.responseId) {
      throw Error('no response id');
    }
  }
}
